import { BsExclamationTriangleFill } from 'react-icons/bs';

import { partesTrabajoDiarioItemsWorkReport } from '../../../../../utils/globalPropTypes';
import { getUrlWithSessionCreds } from '../../../../../utils/globalFunctions';
import { apiCertificationsApp } from '../../../../../resources/environmentConstants';
import ComponentWithTooltip from '../../../../ComponentWithTooltip/ComponentWithTooltip';

import styles from './ExpertReview.module.scss';

const ExpertReview = ({ dailyWorkReport }) => {
  const { fecha, lineaSap, posicionSap, ubicacion, nroSolicitud } = dailyWorkReport;

  const date = fecha.split('T')[0];
  const positionNumber = posicionSap.split(' - ')[0];
  const lineNumber = lineaSap.split(' - ')[0];

  const searchParams = new URLSearchParams();

  const encodedLocation = encodeURIComponent(ubicacion);

  searchParams.set('name', encodedLocation);
  searchParams.set('request', nroSolicitud);
  searchParams.set('date', date);
  searchParams.set('positionLine', `${positionNumber}-${lineNumber}`);

  const urlWithCredentials = getUrlWithSessionCreds(`${apiCertificationsApp}/#/inspeccion/partes`);

  return (
    <ComponentWithTooltip id="hidden-tooltip" tooltipText="Error">
      <a
        aria-label="Sistema experto"
        className={`${styles.link} ${!dailyWorkReport.tieneErrorSE ? styles['link-disabled'] : ''}`}
        href={`${urlWithCredentials}&${searchParams.toString()}`}
      >
        <BsExclamationTriangleFill />
      </a>
    </ComponentWithTooltip>
  );
};

export default ExpertReview;

ExpertReview.propTypes = {
  dailyWorkReport: partesTrabajoDiarioItemsWorkReport.isRequired
};
